import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { orange } from "@material-ui/core/colors";

export const parseExtension = name =>
  name.match(/\.[^.]*$|$/i)[0].toLowerCase();

export const acceptRegex = accept =>
  new RegExp(
    "^(" + accept.replace(/[, ]+/g, "|").replace(/\/\*/g, "/.*") + ")$",
    "i",
  );

export const isValidType = (accept, type) =>
  !accept || acceptRegex(accept).test(type);

export const isValidExtension = (accept, extension) =>
  !accept || acceptRegex(accept).test(extension);

export const isValidAccept = (accept, file) =>
  !accept ||
  isValidType(accept, file.type) ||
  isValidExtension(accept, parseExtension(file.name));

export const isValidMaxSize = (maxSize, size) => {
  if (!maxSize && typeof maxSize !== "number") {
    return true;
  }

  const maxSizeNum = parseInt(maxSize, 10);
  return isNaN(maxSizeNum) ? false : size <= maxSizeNum;
};

const useStyles = makeStyles(theme => ({
  button: {
    height: "inherit",
    width: "100%",
  },

  buttonLabel: {
    display: "block",
    textAlign: "center",
  },

  uploadIcon: {
    color: theme.palette.primary.main,
    fontSize: "3rem",
  },

  fileInput: {
    display: "none",
  },
}));

const FileUploadInputButton = props => {
  const [fileInput, setFileInput] = useState(null);
  const classes = useStyles();

  const fileChanged = file => {
    if (!isValidAccept(props.accept, file)) {
      return;
    }

    if (!isValidMaxSize(props.maxSize, file.size)) {
      return;
    }

    if (props.onChange) {
      props.onChange(file);
    }
  };

  return (
    <div>
      <input
        className={classes.fileInput}
        ref={fileInput => setFileInput(fileInput)}
        type="file"
        accept={props.accept}
        onChange={e => fileChanged(e.currentTarget.files[0])}
      />
      <Tooltip title={props.tooltip || "Select File"}>
        <IconButton
          classes={{ root: classes.button, label: classes.buttonLabel }}
          onClick={() => fileInput.click()}
          disabled={!!props.value || props.disabled}
        >
          <div>
            <CloudUploadIcon
              fontSize="large"
              style={{ color: orange[500] }}
            />
          </div>
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default FileUploadInputButton;
